import React from "react";
import { Modal } from "react-bootstrap";
import PreAuthorizationResponse from "./PrauthorizationView";

const ViewPreauthorizationModal = ({ show, setShow, row }) => {
  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      fullscreen="lg-down"
      dialogClassName="fullscreen-modal"
    >
      <Modal.Header
        closeButton
        className="sticky-top  z-3"
        style={{ top: 0 }}
      >
        <h5 className="fs-10">View Preauthorization</h5>
      </Modal.Header>

      <Modal.Body
        className="overflow-auto"
        style={{ maxHeight: "calc(100vh - 70px)" }} // Adjust based on header height
      >
        <PreAuthorizationResponse row={row} show={show} isHistory={true} />
      </Modal.Body>
    </Modal>
  );
};

export default ViewPreauthorizationModal;
